// src/js/main/questionBuilder.js

function initializeCategoryToggles() {
    const compareBtn = document.getElementById('compare-btn');
    const comparisonSection = document.querySelector('.category-comparison');
    const menuButtons = document.querySelectorAll('.menu-button');
    const categories = document.querySelectorAll('.category-content');

    if (compareBtn && comparisonSection) {
        compareBtn.addEventListener('click', () => {
            compareBtn.classList.toggle('active');
            comparisonSection.classList.toggle('visible');
        });
    }

    if (menuButtons.length > 0 && categories.length > 0) {
        menuButtons.forEach(button => {
            button.addEventListener('click', () => {
                const targetCategory = button.dataset.category;

                menuButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                categories.forEach(category => {
                    category.classList.toggle('active', category.id === targetCategory);
                });

                // Anropa en global uppdatering av scrollers om den finns.
                // Detta kräver att scroller-funktionen är tillgänglig globalt
                // eller skickas in som ett beroende. Vi löser det genom att
                // trigga ett anpassat event.
                window.dispatchEvent(new CustomEvent('updateAllScrollers', { detail: { instant: true } }));
            });
        });
    }
    console.log('Question Builder: Category Toggles initialized.');
}

function initializeScrollers() {
    const scrollers = document.querySelectorAll('.option-scroller');
    if (scrollers.length === 0) return;

    const allScrollers = [];

    function updateScroller(scroller, instant = false) {
        // ... (din befintliga, korrekta scroller-logik här) ...
         if (scroller.items.length <= 2) return;
        if (instant) scroller.list.style.transition = 'none';

        const itemHeight = scroller.items[1].offsetHeight;
        const windowHeight = scroller.list.parentElement.offsetHeight;
        const offset = (windowHeight / 2) - (itemHeight / 2);

        scroller.list.style.transform = `translateY(-${(scroller.activeIndex * itemHeight) - offset}px)`;
        scroller.items.forEach((item, index) => item.classList.toggle('active', index === scroller.activeIndex));

        if (instant) {
            scroller.list.offsetHeight; 
            scroller.list.style.transition = '';
        }
    }

    function updateAllScrollers(instant = false) {
        setTimeout(() => {
            allScrollers.forEach(scroller => updateScroller(scroller, instant));
        }, 0);
    }

    scrollers.forEach(scroller => {
        const items = scroller.querySelectorAll('li');
        const scrollerInstance = {
            list: scroller.querySelector('.options-list'),
            items: items,
            upButton: scroller.querySelector('.scroll-up'),
            downButton: scroller.querySelector('.scroll-down'),
            activeIndex: items.length >= 2 ? 1 : 0
        };
        allScrollers.push(scrollerInstance);

        scrollerInstance.upButton.addEventListener('click', () => {
            if (scrollerInstance.activeIndex > 1) scrollerInstance.activeIndex--;
            else scrollerInstance.activeIndex = scrollerInstance.items.length - 2;
            updateScroller(scrollerInstance, false);
        });

        scrollerInstance.downButton.addEventListener('click', () => {
            if (scrollerInstance.activeIndex < scrollerInstance.items.length - 2) scrollerInstance.activeIndex++;
            else scrollerInstance.activeIndex = 1;
            updateScroller(scrollerInstance, false);
        });
    });

    // Lyssna efter det anpassade eventet från kategoribytaren
    window.addEventListener('updateAllScrollers', (e) => {
        updateAllScrollers(e.detail.instant);
    });

    updateAllScrollers(true);
    window.addEventListener('resize', () => updateAllScrollers(true));
    console.log('Question Builder: Scrollers initialized.');
}

function initializeCopyButtons() {
    // ... (din befintliga, korrekta copy-logik här) ...
    const copyButtons = document.querySelectorAll('.copy-btn');
    if (copyButtons.length === 0) return;

    copyButtons.forEach(button => {
        button.addEventListener('click', () => {
            const questionTextContainer = button.closest('.question-text');
            const activeScrollerOption = questionTextContainer.querySelector('.option-scroller li.active');
            const staticText = Array.from(questionTextContainer.childNodes)
                .filter(node => node.nodeType === Node.TEXT_NODE || node.classList?.contains('static-text'))
                .map(node => node.textContent.trim())
                .join(' ');

            const fullQuestion = `${staticText} ${activeScrollerOption ? activeScrollerOption.textContent.trim() : ''}`.trim();

            navigator.clipboard.writeText(fullQuestion).then(() => {
                const copyTextSpan = button.querySelector('.copy-text');
                const originalText = copyTextSpan ? copyTextSpan.textContent : "Kopiera";
                if(copyTextSpan) copyTextSpan.textContent = 'Kopierad!';
                button.classList.add('copied');

                setTimeout(() => {
                    if(copyTextSpan) copyTextSpan.textContent = originalText;
                    button.classList.remove('copied');
                }, 2000);
            }).catch(err => {
                console.error('Kunde inte kopiera text: ', err);
            });
        });
    });
    console.log('Question Builder: Copy Buttons initialized.');
}

// Huvud-event listener
document.addEventListener('DOMContentLoaded', () => {
    initializeCategoryToggles(); // Tillagd
    initializeScrollers();
    initializeCopyButtons();
});